export default {
  ActivityLogImportJob: 'Activity Log Import',
  AllSurveysDataMigrationJob: 'All Surveys Data Migration',
  ArenaMobileDataImportJob: 'Arena Data Import',
  ArenaMobileDataImportSummaryJob: 'Arena Data Import Summary',
  CategoriesImportJob: 'Categories Import',
  CategoriesValidationJob: 'Categories Validation',
  CategoriesBatchImportJob: 'Categories Import',
  CategoryImportJob: 'Category Import',
  CategoryImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportJob: '$t(jobs:CategoryImportJob)',
  CategoryValidationJob: 'Category Validation',
  ChainsSamplingNodeDefsCheckJob: 'Processing Chains Sampling Node Definitions Creation',
  ChainsValidationJob: 'Processing Chains Validation',
  ChainsImportJob: 'Chains Import',
  CollectDataImportJob: 'Collect Data Import',
  CollectImportJob: 'Collect Import',
  CollectSurveyReaderJob: 'Collect Survey Reader',
  CyclesDeletedCheckJob: 'Deleted Cycles Check',
  DataDeleteJob: 'Data Delete',
  DataImportJob: 'Data Import',
  DataImportValidationJob: 'Data Import File Validation',
  EntitiesDeleteJob: 'Existing Entities Delete',
  FilesImportJob: 'Files Import',
  MessageSendJob: 'Message Send',
  NodeDefsTranslationJob: 'Node Definitions Labels Translation',
  NodeDefsImportJob: 'Node Definitions Import',
  NodeDefsValidationJob: 'Node Definitions Validation',
  chainsCyclesCheckJob: `Chains Cycles Check`,
  RecordCheckJob: 'Record Check',
  RecordsCloneJob: 'Records Clone',
  RecordsImportJob: 'Records Import',
  RecordsUniquenessValidationJob: 'Records Uniqueness Validation',
  SamplingPointDataImportJob: 'Sampling Point Data Import',
  SchemaSummaryExportJob: 'Schema Summary Export',
  SurveyActivityLogClearJob: 'Survey Activity Log Clear',
  SurveyCreatorJob: 'Survey Create',
  SurveyDependencyGraphsGenerationJob: 'Survey Dependency Graph Generation',
  SurveyExportJob: 'Survey Export',
  SurveyFilesImportJob: 'Survey Files Import',
  SurveyIndexGeneratorJob: 'Survey Index Generator',
  SurveyInfoValidationJob: 'Survey Info Validation',
  SurveyLabelsImportJob: 'Survey Labels Import',
  SurveyPropsPublishJob: 'Survey Props Publish',
  SurveyPublishJob: 'Survey Publish',
  SurveyPublishPerformJob: 'Survey Publish Perform',
  SurveyRdbCreationJob: 'Survey RDB Creation',
  SurveyUnpublishJob: 'Survey Unpublish',
  SurveyPropsUnpublishJob: 'Survey props upublish',
  SurveysListExportJob: 'Surveys list export',
  TaxonomiesImportJob: 'Taxonomies Import',
  TaxonomiesValidationJob: 'Taxonomies Validation',
  TaxonomyImportJob: 'Taxonomy Import',
  // data export
  ArenaFileReadJob: 'Arena File Read',
  DataExportJob: 'Data Export',
  DataSummaryExportJob: 'Data Summary Export',
  ZipCreationJob: 'ZIP File Creation',
  CSVDataExtraction: 'Data Extraction',
  PrepareImportFileJob: 'Prepare Import File',
  // geo
  GeoJsonDataExportJob: 'GeoJson Data Export',
  // import arena survey
  ArenaImportJob: 'Arena import',
  ArenaSurveyReaderJob: 'Arena Survey Reader',
  CreateRdbJob: 'Survey RDB Creation',
  UsersImportJob: 'Users Import',
  // clone survey
  SurveyCloneJob: 'Clone survey',
  CloneSurveyJob: 'Clone survey',
  // survey backup
  SurveyInfoExportJob: 'Survey Info Export',
  CategoriesExportJob: 'Categories Export',
  TaxonomiesExportJob: 'Taxonomies Export',
  RecordsExportJob: 'Records Export',
  RecordFilesExportJob: 'Record Files Export',
  SurveyFilesExportJob: 'Survey Files Export',
  ChainExportJob: 'Chain Export',
  UsersExportJob: 'Users Export',
  ActivityLogExportJob: 'Activity Log Export',
  InfoExportJob: 'Output File Info Generation',
  // validation Report
  VaidationReportGenerationJob: 'Generate Validation Report',
  // record Validation
  RecordsValidationJob: `Records' validation`,
  // analysis
  PersistResultsJob: 'Persist Analysis Results',
  elapsed: 'Elapsed',
  remaining: 'Remaining',
}
